import { uri } from '../../api-endpoint';
import {
  IProjectImageInfoAPIValidationError,
  IProjectImageInfoListFromAPISuccessResponse
} from '../../type-conversion/project-image-info/from-api-repsonse';
import { ProjectImageInfoAPIRequestBody } from '../../type-conversion/project-image-info/to-api-request-body';
import { createTemplateFn } from '../common';

export const createProjectImage = (token: string) => (projectId: number) =>
  createTemplateFn(
    token,
    uri.projectImageList(projectId),
    ProjectImageInfoAPIRequestBody,
    IProjectImageInfoListFromAPISuccessResponse,
    IProjectImageInfoAPIValidationError
  );
